import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Components
import Layout from './components/layout/Layout';
import ScrollToTop from './components/common/ScrollToTop';
import { DataProvider } from './context/DataProvider';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import ELearning from './pages/ELearning';
import JoinUs from './pages/JoinUs';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import CourseDetail from './pages/CourseDetail';
import UIUXCourse from './pages/UIUXCourse';
import ShippingPolicy from './pages/ShippingPolicy';
import RefundPolicy from './pages/RefundPolicy';
import Projects from './pages/Projects';
import AppPrivacyPolicy from './pages/AppPrivacyPolicy';

// Academy Pages
import Academy from './pages/Academy';
import UIUXDesign from './pages/courses/UIUXDesign';
import AppDevelopment from './pages/courses/AppDevelopment';
import FreeMasterclass from './pages/FreeMasterclass';
import Mentors from './pages/Mentors';
import SuccessStories from './pages/SuccessStories';
import PricingBatches from './pages/PricingBatches';
import CertificateVerification from './pages/CertificateVerification';
import CorporateTraining from './pages/CorporateTraining';
import Blog from './pages/Blog';
import CourseFAQ from './pages/CourseFAQ';
import Community from './pages/Community';

function App() {
  return (
    <HelmetProvider>
      <DataProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/uiux-design-ai-course" element={<UIUXCourse />} />
            <Route path="*" element={<LayoutWrapper />} />
          </Routes>
        </Router>
      </DataProvider>
    </HelmetProvider>
  );
}

function LayoutWrapper() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:serviceId" element={<ServiceDetail />} />
        {/* <Route path="/e-learning" element={<ELearning />} /> */}
        {/* <Route path="/e-learning/course/:courseId" element={<CourseDetail />} /> */}
        <Route path="/join-us" element={<JoinUs />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/app-privacy-policy" element={<AppPrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/projects" element={<Projects />} />

        {/* Academy Routes */}
        <Route path="/academy" element={<Academy />} />
        <Route path="/courses/ui-ux-design-with-ai" element={<UIUXDesign />} />
        <Route path="/courses/app-development-with-ai" element={<AppDevelopment />} />
        <Route path="/free-masterclass" element={<FreeMasterclass />} />
        <Route path="/mentors" element={<Mentors />} />
        <Route path="/success-stories" element={<SuccessStories />} />
        <Route path="/pricing-batches" element={<PricingBatches />} />
        <Route path="/certificate-verification" element={<CertificateVerification />} />
        <Route path="/corporate-training" element={<CorporateTraining />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/course-faq" element={<CourseFAQ />} />
        <Route path="/community" element={<Community />} />

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default App;
